import { z } from 'zod';

export enum DFMCheckType {
  HOLES_COUNT = 'holes_count',
  UNMACHINABLE_HOLES = 'unmachinable_holes',
  THIN_WALLS = 'thin_walls',
  NARROW_GAPS = 'narrow_gaps',
  INTERNAL_VOLUME = 'internal_volume',
  BLOCKING_UP = 'blocking_up',
}

export enum DFMCheckStatus {
  PENDING = 'pending',
  IN_QUEUE = 'in_queue',
  IN_PROGRESS = 'in_progress',
  SAVING = 'saving',
  FAILED = 'failed',
  COMPLETED = 'completed',
}

// BlockingUpBox type for blocking up visualization
export interface BlockingUpBox {
  xSize: number;
  ySize: number;
  zSize: number;
  xCentre: number;
  yCentre: number;
  zCentre: number;
}

export const BlockingUpBoxSchema = z.object({
  xSize: z.number(),
  ySize: z.number(),
  zSize: z.number(),
  xCentre: z.number(),
  yCentre: z.number(),
  zCentre: z.number(),
});

export const DFMCheckSchema = z.object({
  id: z.number(),
  check_type: z.enum([
    DFMCheckType.HOLES_COUNT,
    DFMCheckType.UNMACHINABLE_HOLES,
    DFMCheckType.THIN_WALLS,
    DFMCheckType.NARROW_GAPS,
    DFMCheckType.INTERNAL_VOLUME,
    DFMCheckType.BLOCKING_UP,
  ]),
  cad_object_id: z.number(),
  material_id: z.number(),
  material_name: z.string().nullable(),
  quantity: z.string().nullable(), // DecimalField from backend comes as string
  status: z.enum([
    DFMCheckStatus.PENDING,
    DFMCheckStatus.IN_QUEUE,
    DFMCheckStatus.IN_PROGRESS,
    DFMCheckStatus.SAVING,
    DFMCheckStatus.FAILED,
    DFMCheckStatus.COMPLETED,
  ]),
  created_at: z.string(), // DateTimeField from backend comes as string
  // Blocking Up specific fields (only populated when check_type is BLOCKING_UP)
  blocking_up: z.array(BlockingUpBoxSchema).nullable().optional(),
  num_sheets_needed: z.number().nullable().optional(),
  blocking_up_step_file_url: z.string().nullable().optional(),
  dfm_check_parameters: z.record(z.string(), z.number()).nullable().optional(),
});

export type DFMCheck = z.infer<typeof DFMCheckSchema>;
